'use client';

import { useCallback } from 'react';
import { useYandexMetrika } from '../../../hooks/useYandexMetrika';

export type WikiGoal = 'wiki_search' | 'wiki_shot_click';

export function useWikiGoal(): (goal: WikiGoal) => void {
  const { counterId } = useYandexMetrika();
  return useCallback(
    (goal: WikiGoal) => {
      if (counterId) window.ym?.(counterId, 'reachGoal', goal);
    },
    [counterId],
  );
}
